import generateHeaders from "../utils/generateHeaders";
import api from "./index";

export const createCredentialReport = async (token, body) => {
  const headers = generateHeaders(token);

  return await api.post(`/async/credential-report`, body, headers);
};

export const getCredentialReportStatus = async (reportId) => {
  return await api.get(`/async/credential-report/${reportId}`);
};
